import React from 'react';
import { WizardContainer } from 'modules/product/wizard/pages';
import { MarketplaceOrderEditViewStore } from 'modules/order/stores/wizard';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new MarketplaceOrderEditViewStore(rootStore), 'marketplaceOrderEditViewStore')
class MarketplaceOrderEdit extends React.Component {
	render() {
		const {
			marketplaceOrderEditViewStore: {
				config,
				form,
				localStorageKey,
				isEdit,
				applyToAllActiveOrdersConfirmModal,
				loading,
				handleBackButtonClick,
			},
		} = this.props;
		return (
			<div>
				<WizardContainer
					config={config}
					itemName={isEdit ? 'MARKETPLACEORDEREDITFORM.TITLE.UPDATE' : 'MARKETPLACEORDEREDITFORM.TITLE.CREATE'}
					form={form}
					localStorageKey={localStorageKey}
					applyToAllActiveOrdersConfirmModal={applyToAllActiveOrdersConfirmModal}
					disabled={loading}
					goBack={handleBackButtonClick}
				/>
			</div>
		);
	}
}

export default MarketplaceOrderEdit;



// WEBPACK FOOTER //
// ./src/modules/order/pages/MarketplaceOrderEdit.jsx